import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { OhayoUtilModule } from '@ohayojp/util';
import { ACLIfDirective } from './acl-if.directive';
import { ACLDirective } from './acl.directive';
import { ACLService } from './acl.service';

const COMPONENTS = [ACLDirective, ACLIfDirective];

@NgModule({
  imports: [CommonModule, OhayoUtilModule],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class OhayoACLModule {
  static forRoot(): ModuleWithProviders<OhayoACLModule> {
    return {
      ngModule: OhayoACLModule,
      providers: [ACLService],
    };
  }
}
